import ObjectText from './object.text.js'

export default class ObjectJson extends ObjectText {

}